import { Link } from 'react-router-dom'
import Icon from '../components/Icon'
import PageHero from '../components/PageHero'
import PipedriveForm from '../components/PipedriveForm'
import Process from '../components/sections/Process'
import Reveal from '../components/Reveal'
import { Section } from '../components/Section'
import { company } from '../data/site'
import { contactPageJsonLd, useJsonLd, useSeo } from '../lib/seo'

const kontaktJsonLd = contactPageJsonLd()

export default function Kontakt() {
  useSeo({
    title: 'Kontakt',
    description:
      'Kontaktieren Sie CASA Hausverwaltung - telefonisch unter +49 7424 6053100, per E-Mail an info@casa-hausverwaltung.de oder über das Anfrageformular.',
    path: '/kontakt',
  })
  useJsonLd(kontaktJsonLd, 'contact')

  /* Every value is a company fact from data/site.js, so the tiles cannot drift
     from the Impressum. */
  const tiles = [
    {
      icon: 'phone',
      label: 'Telefon',
      value: company.phone,
      href: company.phoneHref,
      meta: 'Direkt ins Team - ohne Warteschleife.',
    },
    {
      icon: 'mail',
      label: 'E-Mail',
      value: company.email,
      href: company.emailHref,
      meta: 'Antwort innerhalb eines Werktages.',
    },
    {
      icon: 'pin',
      label: 'Adresse',
      value: `${company.street}, ${company.postalCode} ${company.city}`,
      meta: `${company.legalName} · ${company.licence}`,
    },
  ]

  return (
    <>
      <PageHero
        eyebrow="Kontakt"
        title="Kontaktieren Sie uns"
        lead="Wir stehen Ihnen für alle Anliegen rund um die Immobilienverwaltung zur Verfügung - für Eigentümer, Eigentümergemeinschaften und Mieter."
        breadcrumb={[{ label: 'Kontakt' }]}
      />

      <Section>
        <div className="split split--copy-narrow" style={{ alignItems: 'start' }}>
          <Reveal>
            <p className="eyebrow">Direkt erreichbar</p>
            <h2 style={{ marginTop: 'var(--s-4)', marginBottom: 'var(--s-5)' }}>
              So erreichen Sie uns
            </h2>

            <div className="contact-tiles">
              {tiles.map((tile) => (
                <div className="contact-tile" key={tile.label}>
                  <span className="contact-tile__icon">
                    <Icon name={tile.icon} />
                  </span>
                  <div>
                    <span className="contact-tile__label">{tile.label}</span>
                    {tile.href ? (
                      <a className="contact-tile__value" href={tile.href}>
                        {tile.value}
                      </a>
                    ) : (
                      <span className="contact-tile__value">{tile.value}</span>
                    )}
                    <p className="contact-tile__meta">{tile.meta}</p>
                  </div>
                </div>
              ))}
            </div>

            <div
              className="card card--paper"
              style={{ marginTop: 'var(--s-6)', display: 'grid', gap: 'var(--s-3)' }}
            >
              <h3 style={{ fontSize: 'var(--step-1)' }}>
                Ihr Feedback ist uns wichtig
              </h3>
              <p style={{ margin: 0, fontSize: 'var(--step--1)' }}>
                Lob, Kritik oder ein Hinweis, der uns besser macht? Schreiben Sie
                uns an{' '}
                <a href={`${company.emailHref}?subject=Feedback`}>{company.email}</a>.
              </p>
            </div>

            <div
              className="card"
              style={{ marginTop: 'var(--s-4)', display: 'grid', gap: 'var(--s-3)' }}
            >
              <h3 style={{ fontSize: 'var(--step-1)' }}>
                Sie sind Mieter und möchten einen Schaden melden?
              </h3>
              <p style={{ margin: 0, fontSize: 'var(--step--1)' }}>
                Am schnellsten geht das über die CASA App - inklusive Fotoanhang
                und Statusverfolgung. Wie Sie Zugang erhalten, steht auf der{' '}
                <Link to="/casa-app">Seite zur CASA App</Link>.
              </p>
            </div>
          </Reveal>

          <Reveal>
            <div className="card" style={{ padding: 'clamp(1.5rem, 3vw, 2.5rem)' }}>
              <p className="eyebrow">Anfrageformular</p>
              <h2
                style={{
                  marginTop: 'var(--s-4)',
                  marginBottom: 'var(--s-3)',
                  fontSize: 'var(--step-2)',
                }}
              >
                Kostenloses Erstgespräch anfragen
              </h2>
              <p style={{ marginBottom: 'var(--s-6)', fontSize: 'var(--step--1)' }}>
                Ein paar Angaben zu Ihrem Objekt genügen. Wir melden uns
                telefonisch und vereinbaren einen Vor-Ort-Termin.
              </p>
              <PipedriveForm />
            </div>
          </Reveal>
        </div>
      </Section>

      <Process />
    </>
  )
}
